<h2 mat-dialog-title>{{'Registration' | translate}}</h2>
<mat-dialog-content class="mat-typography">
  <div class="input-row">
        <h3>{{"Competitor's card" | translate}}</h3>
        <mat-form-field appearance="fill" style="min-width: 236px">
          <mat-label>{{'Country' | translate}}</mat-label>
          <mat-select [(value)]="selectedCountry" [formControl]="countryFieldControl">
            <mat-option *ngFor="let country of countries"
                        value="{{country}}">
              {{country | translate}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="countryFieldControl.invalid">{{getErrorMessage(countryFieldControl) | translate}}</mat-error>
        </mat-form-field>
    <p>
      <mat-form-field appearance="fill" style="min-width: 236px">
        <mat-label>{{'Enter your first name' | translate}}</mat-label>
        <input matInput placeholder="First name" [(ngModel)]="firstName" [formControl]="firstNameFieldControl" required>
        <mat-error *ngIf="firstNameFieldControl.invalid">{{getErrorMessage(firstNameFieldControl) | translate}}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" style="min-width: 236px">
        <mat-label>{{'Enter your last name' | translate}}</mat-label>
        <input matInput placeholder="Last name" [(ngModel)]="lastName" [formControl]="lastNameFieldControl" required>
        <mat-error *ngIf="lastNameFieldControl.invalid">{{getErrorMessage(lastNameFieldControl) | translate}}</mat-error>
      </mat-form-field>
    </p>
    <p>
      <mat-form-field appearance="fill" style="min-width: 236px">
        <mat-label>{{'Enter ID card number' | translate}}</mat-label>
        <input matInput placeholder="ID card number" [(ngModel)]="idNumber" [formControl]="idNumberFieldControl" required>
        <mat-error *ngIf="idNumberFieldControl.invalid">{{getErrorMessage(idNumberFieldControl) | translate}}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" class="example-form-field" style="min-width: 236px">
        <mat-label>{{'Enter your date of birth' | translate}}</mat-label>
        <input matInput [matDatepicker]="datepicker" [(ngModel)]="dateOfBirth" [formControl]="dateOfBirthFieldControl" required>
        <mat-error *ngIf="dateOfBirthFieldControl.invalid">{{getErrorMessage(dateOfBirthFieldControl) | translate}}</mat-error>
        <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
        <mat-datepicker #datepicker></mat-datepicker>
      </mat-form-field>
    </p>
    <p>
      <mat-form-field appearance="fill" style="min-width: 236px">
        <mat-label>{{'Enter your address' | translate}}</mat-label>
        <input matInput placeholder="Address" [(ngModel)]="address" [formControl]="addressFieldControl" required>
        <mat-error *ngIf="addressFieldControl.invalid">{{getErrorMessage(addressFieldControl) | translate}}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" style="min-width: 236px">
        <mat-label>{{'Enter your phone number' | translate}}</mat-label>
        <input matInput placeholder="Phone" [(ngModel)]="phone" [formControl]="phoneFieldControl" required>
        <mat-error *ngIf="phoneFieldControl.invalid">{{getErrorMessage(phoneFieldControl) | translate}}</mat-error>
      </mat-form-field>
    </p>
  </div>
  <mat-error *ngIf="serverIsDown">{{'Server problem, contact an administrator' | translate}}</mat-error>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{'Cancel' | translate}}</button>
  <button  mat-button (click)="onSaveCompetitorCard()" [disabled]="allFieldsAreFilled()">{{'Create competitor card' | translate}}</button>
</mat-dialog-actions>
